import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import Loading from './components/Loading';
import LeftPanel from './components/LeftPanel';
import MapArea from './components/MapArea';
import RightPanel from './components/RightPanel';
import ExhibitorList from './components/ExhibitorList';
import MyFavourites from './components/MyFavourites';
import ExhibitionInfo from './components/ExhibitionInfo';
import ExhibitorInfo from './components/ExhibitorInfo';
import './sass/index.sass';
import useData from './hooks/useData';
import ExhibitorListPrint from './components/ExhibitorListPrint';
import SearchPanel from './components/SearchPanel';

const currentUrl = window.location.href;
const root = ReactDOM.createRoot(document.getElementById('root'));
let className = '';

const MultiFloor = () => {
	const { floorInfo } = useData();

	const filteredFloorInfo = useMemo(() => {
		return floorInfo.filter((floor) => {
			return floor.floor !== '';
		});
	}, [floorInfo]);

	useEffect(() => {
		document.body.style.overflow = 'auto';
		document.documentElement.style.overflow = 'auto';

		setTimeout(() => {
			window.print();
		}, 2000);
	}, []);

	return (
		<div id='App' className='multi-floor' >
			{filteredFloorInfo.map((floor, index) => {
				return (
					<MapArea isPrint floor={floor} key={`map${index}`} />
				);
			})}
			<Loading />
		</div>
	);
};

const urlParams = new URLSearchParams(window.location.search);
const Location = urlParams.get('location');
const Start = urlParams.get('start');
if (Location) localStorage.setItem('Location', Location);
if (Start) localStorage.setItem('Start', Start);

if (currentUrl.includes('single-floor')) {
	root.render(
		<div id='App' className='single-floor'>
			<MapArea isPrint />
			<Loading />
		</div>
	);
}

else if (currentUrl.includes('multi-floor')) {
	root.render(<MultiFloor />);
}

else if (currentUrl.includes('exhibitor-list')) {
	root.render(<ExhibitorListPrint />);
}

else {
	root.render(
		<div id='App' className={className}>
			<LeftPanel />
			<MapArea />
			<RightPanel />
			<ExhibitorList />
			<MyFavourites />
			<ExhibitionInfo />
			<ExhibitorInfo />
			<SearchPanel />
			<Loading />
		</div>
	);
}



// fetch('https://nas.bizlion.com.tw:8008/cf/recommendation_v1/run', {
// 	method: 'POST',
// 	headers: {
// 		'Content-Type': 'application/json',
// 	},
// 	body: JSON.stringify([{
// 		uuid: 'DCFA61F5-80DD-4FAA-B303-5D5FA117B191',
// 		userid: 'test',
// 		triggerID_1: 'P514',
// 		triggerID_2: '',
// 		triggerID_3: '',
// 	}]),
// })
// 	.then((response) => {
// 		console.log(response);
// 	});